"use client";
import styled from "styled-components";
import { Fonts } from "../styles/globalsStyles";
import { defaultTheme } from "../styles/defaultTheme";

export const OutsideLink = styled.a`
  position: relative;
  color: ${defaultTheme.primaryColor};
  ${Fonts.large}
  font-weight: bold;
  /* width: min-content; */
  text-decoration: none;
  overflow: hidden;
  transition: color 0.3s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 1px;
    background-color: ${defaultTheme.secondaryColor};
    transition: width 0.3s ease-in-out;
  }

  &:hover {
    color: ${defaultTheme.secondaryColor};
    cursor: pointer;
    &::before {
      width: 100%;
    }
  }
`;
